import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';
import _ from 'lodash';

export default function engagementhelixreducer(state = initialState.engagementHelixProjects, action) {
	switch (action.type) {
		case actions.GET_AVAILABLE_PROJECT_FROM_CANAVS_ENGAGEMENT: {
			if (!action.error) {
				const helixData = getHelixProjectAttributes(action.response);
				return [{isLoadedAvailableHelixProjects: true}, ...(helixData || state)];
			}
			return state;
		}
		default:
			return state;
	}
}

function getHelixProjectAttributes(helixConnections) {
	if (!Array.isArray(helixConnections)) return [];

	return helixConnections.map((helixConnection) => {
		const connections = helixConnection?.connections || {};
		const attrs = helixConnection?.trialBalanceAttributeJson || {};

		return {
			engagementHelixId: connections.engagementHelixId,
			projectId: connections.projectId,
			projectName: connections.projectName,
			isPrimary: helixConnection?.trialBalanceTypeId === 1,
			helixJson: null,
			helixImportDate: null,
			helixImportUserID: null,
			helixImportUserName: '',
			currentperioddate: helixConnection.currentperioddate,
			comparativeperioddate: helixConnection.comparativeperioddate,
			othercomparativeperioddate: helixConnection.othercomparativeperioddate,
			id: helixConnection.id,
			helixImportStatusID: connections.importStatusId ?? helixConnection?.importStatusId,
			helixProjectAttributesReadModel: {
				currencyType: attrs.currencyType,
				currencyCode: attrs.currencyCode,
				roundingNumber: attrs.roundingNumber,
				businessUnit: attrs.businessUnit,
				businessUnitTiles: attrs.businessUnitTiles,
				isAllBusinessUnitSelected: attrs.isAllBusinessUnitSelected,
				projectCountryCode: attrs.isAllBusinessUnitSelected,
				projectRegion: attrs.projectRegion,
				projectSubscriptionId: attrs.projectSubscriptionId,
				analysisPeriod: attrs.analysisPeriod,
				comparativePeriod: attrs.comparativePeriod,
				secondComparativePeriod: attrs.secondComparativePeriod,
				connectionTypes: attrs.connectionTypes,
				businessUnits: attrs.businessUnits,
				stEntityBusinessUnits: attrs.stEntityBusinessUnits
			},
			helixJsonModel: null,
			isRetryAllowed: false,
			helixAnalyzerId: connections.helixAnalyzerID,
			helixAnalyzerName: connections.helixAnalyzerName,
			helixAnalyzerType: connections.helixAnalyzerType,
			hasClientAnalytics: null,
			customName: connections.customName,
			trialBalances: attrs,
			uniqueId: connections.connectionUniqueIdentifier,
			trialBalanceId: helixConnection?.id
		};
	});
}
